import React, { useEffect, useState } from 'react';
import '../Home/Home.css';
import axios from 'axios';
import { Link } from 'react-router-dom';
import ReactTypingEffect from 'react-typing-effect';
import { useSelector } from 'react-redux';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const Home = () => {
  const [blogs, setBlogs] = useState([]);
  const [search, setSearch] = useState('');
  const [limit, setLimit] = useState(2);
  const [loading, setLoading] = useState(true);
  const isLoggedIn = useSelector((state) => state.isLoggedIn);

  const sendRequest = async () => {
    try {
      const { data } = await axios.get(`https://new-blog-server.onrender.com/api/blog/all-blog?limit=${limit}`);
      if (data?.success) {
        setBlogs(data?.blogs);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    sendRequest();
  }, [limit]);

  const handleLoadMore = () => {
    setLimit((prevLimit) => prevLimit + 2);
  };
  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  const filteredBlogs = search.trim() === ' ' ? blogs : blogs.filter((blog) => {
    return (blog && (blog.title.toLowerCase().includes(search.toLowerCase()) || blog.description.toLowerCase().includes(search.toLowerCase())));
  });
  if (!filteredBlogs.length === 0) {
    return <h1 className='text-center'>No search Found</h1>;
  }
  const random = Math.floor(Math.random() * blogs.length)
  return (
    <>
      <section id='blog-section'>
        <div className='hero-container'>
          <div className='row justify-content-center'>
            <div className='col-md-4'>
              {loading ? (<Skeleton height={50} width={350} />) : (<><h2 className='hero-title'>{filteredBlogs[random]?.title.slice(0, 50)}</h2></>)}

              {loading ? (<Skeleton height={40} width={350} style={{ marginTop: '10%' }} />) : (<> <h5 className='hero-desc'>{filteredBlogs[random]?.description.slice(0, 100)}.....</h5></>)}
              {loading ? (<Skeleton height={40} width={350} style={{ marginTop: '10%', textAlign: 'end' }} />) : (<> <h6 className='hero-desc'>by {filteredBlogs[random]?.user.username}</h6></>)}
              {loading ? (<Skeleton height={40} width={200} style={{ marginTop: '20%' }} />) : (<> <Link to={`/get-blog/${filteredBlogs[random]?._id}`}> <button className='hero-btn'>Read More <i class="fa-solid fa-chevron-right"></i></button></Link></>)}
            </div>
            <div className='col-md-8'>
              {loading ? (<Skeleton height={400} width={600} />) : (<><img src={filteredBlogs[random]?.image} className='img-fluid' /></>)}

            </div>
          </div>
        </div>

        <div className='container'>
          <div className='row'>
            {loading ? (
              Array.from({ length: 6 }).map((_, index) => (
                <div className='col-md-4' key={index}>
                  <div className='blog-wrapper'>
                    <Skeleton height={200} />
                    <div className='blog-body'>
                      <Skeleton height={20} width={100} />
                      <Skeleton height={12} width={150} />
                      <Skeleton height={12} width={100} />
                      <Skeleton height={12} width={80} />
                      <Skeleton height={12} width={120} />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              filteredBlogs.map((blog) => (
                <div className='col-md-4' key={blog._id}>
                  <Link to={`/get-blog/${blog._id}`}>
                    <div className='blog-wrapper' id={blog._id} isUser={localStorage.getItem("userId") === blog?.user?._id}>
                      <img src={blog.image} alt='blog-img' className='blog-img image-fluid mx-auto d-block' /><br />
                      <div className='blog-body'>
                        <div className="blog-header">
                          <h5>{`${blog.title.slice(0, 50)}`}</h5>
                        </div>
                        <small className='text-center mx-auto d-block'>Published On : {blog.createdAt.slice(0, 10)}</small>
                        <hr />
                        <small>{`${blog.description.slice(0, 100)}......`}</small>
                        <h6 className='text-end'>by {blog.user?.username}</h6>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
